import { atom, useAtom } from "jotai";

type ToastOptions = {
  title: string;
  haptic?: "success" | "warning" | "error" | "none";
  preset?: "done" | "error" | "none";
  duration?: number;
};

type ToastState = ToastOptions & { id: number } | null;

export const toastAtom = atom<ToastState>(null);

export function useToast() {
  const [, setToast] = useAtom(toastAtom);

  return (options: ToastOptions) => {
    setToast({ ...options, id: Date.now() });
  };
}
